import { forwardRef, Fragment } from 'react';
import { classes } from '../../../utils/commonUtils';
import css from './seekbar.module.scss';

function getPercent(value: number, min: number, max: number) {
  const edge = value;
  const unit = (max - min) / 100;
  const position = edge - min;
  return position / unit;
}

interface SeekbarProps {
  value: number;
  min: number;
  max: number;
  onChange: (position: number) => void;
  ghostValue?: number;
  step?: number;
  name?: string;
  isLoading?: boolean;
  className?: string;
}

export const Seekbar = forwardRef<HTMLInputElement, SeekbarProps>((props, ref) => {
  const percent = getPercent(props.value, props.min, props.max);
  const ghostPercent = getPercent(props.ghostValue ?? props.value, props.min, props.max);

  return (
    <Fragment>
      <input
        data-is-loading={props.isLoading ?? false}
        className={classes(css.seekbar, props.className)}
        style={{ '--current-percent': `${percent}%`, '--ghost-percent': `${ghostPercent}%` } as React.CSSProperties}
        ref={ref}
        name={props.name}
        type="range"
        step={props.step ?? 1}
        onChange={(event) => props.onChange(parseInt(event.target.value, 10))}
        value={props.value}
        min={props.min}
        max={props.max}
      />
    </Fragment>
  );
});
